/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/

import { icon_apps } from './navigation/apps.icon';
import { icon_arrow_back } from './navigation/arrow_back.icon';
import { icon_arrow_downward } from './navigation/arrow_downward.icon';
import { icon_arrow_drop_down } from './navigation/arrow_drop_down.icon';
import { icon_arrow_drop_down_circle } from './navigation/arrow_drop_down_circle.icon';
import { icon_arrow_drop_up } from './navigation/arrow_drop_up.icon';
import { icon_arrow_forward } from './navigation/arrow_forward.icon';
import { icon_cancel } from './navigation/cancel.icon';
import { icon_check } from './navigation/check.icon';
import { icon_arrow_upward } from './navigation/arrow_upward.icon';
import { icon_chevron_left } from './navigation/chevron_left.icon';
import { icon_expand_less } from './navigation/expand_less.icon';
import { icon_chevron_right } from './navigation/chevron_right.icon';
import { icon_close } from './navigation/close.icon';
import { icon_expand_more } from './navigation/expand_more.icon';
import { icon_first_page } from './navigation/first_page.icon';
import { icon_fullscreen } from './navigation/fullscreen.icon';
import { icon_fullscreen_exit } from './navigation/fullscreen_exit.icon';
import { icon_last_page } from './navigation/last_page.icon';
import { icon_menu } from './navigation/menu.icon';
import { icon_more_horiz } from './navigation/more_horiz.icon';
import { icon_refresh } from './navigation/refresh.icon';
import { icon_subdirectory_arrow_left } from './navigation/subdirectory_arrow_left.icon';
import { icon_subdirectory_arrow_right } from './navigation/subdirectory_arrow_right.icon';
import { icon_more_vert } from './navigation/more_vert.icon';
import { icon_unfold_less } from './navigation/unfold_less.icon';
import { icon_unfold_more } from './navigation/unfold_more.icon';
var icons = {
  "apps" : icon_apps,
"arrow_back" : icon_arrow_back,
"arrow_downward" : icon_arrow_downward,
"arrow_drop_down" : icon_arrow_drop_down,
"arrow_drop_down_circle" : icon_arrow_drop_down_circle,
"arrow_drop_up" : icon_arrow_drop_up,
"arrow_forward" : icon_arrow_forward,
"cancel" : icon_cancel,
"check" : icon_check,
"arrow_upward" : icon_arrow_upward,
"chevron_left" : icon_chevron_left,
"expand_less" : icon_expand_less,
"chevron_right" : icon_chevron_right,
"close" : icon_close,
"expand_more" : icon_expand_more,
"first_page" : icon_first_page,
"fullscreen" : icon_fullscreen,
"fullscreen_exit" : icon_fullscreen_exit,
"last_page" : icon_last_page,
"menu" : icon_menu,
"more_horiz" : icon_more_horiz,
"refresh" : icon_refresh,
"subdirectory_arrow_left" : icon_subdirectory_arrow_left,
"subdirectory_arrow_right" : icon_subdirectory_arrow_right,
"more_vert" : icon_more_vert,
"unfold_less" : icon_unfold_less,
"unfold_more" : icon_unfold_more,
};
export { icons };
